<template>
    <div class="radio" :class="{ active: isCheck }">
        <div class="header" @click="handleChangeSwitch">
            <div class="title">{{ title }}</div>
            <img v-if="!isDarkSkin" :src="isCheck ? on : off" alt="" />
            <img v-else :src="isCheck ? bon : boff" />
        </div>
        <div class="desc" v-if="desc" v-html="desc"></div>
        <div
            v-if="isShowImage && image.url"
            class="img-wrap"
            v-for="image in imageSettings"
            :key="image.url"
            @click="handlePickImage(image)"
        >
            <img :src="image.url" alt="" />
        </div>
        <div class="field-wrap" v-if="isShowFillBlank">
            <van-field
                style="background-color: transparent; padding: 10px;"
                rows="2"
                :autosize="{ minHeight: 40 }"
                type="textarea"
                maxlength="250"
                :placeholder="placeholder"
                v-model="option.inputValue"
                @input="handleInputValueChange"
                @focus="handleFocus"
            />
        </div>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';
import off from '@/assets/images/off_rounded.svg';
import on from '@/assets/images/on_rounded.svg';
import boff from '@/assets/images/checkoff-light@3x.png';
import bon from '@/assets/images/checkon-dark@3x.png';
import { CHANGE_PASS_VALIDATE, DB_ON_QUESTIONNAIR } from '@/libs/constant';
import { mapState } from 'vuex';
import { OptionType } from '@/libs/enum';

export default {
    name: 'radio',
    props: {
        type: {
            type: String,
            default: () => 'multi-group'
        },
        value: {
            type: [Number, String],
            default: () => ''
        },
        img: {
            type: String,
            default: () => require('@/assets/images/demo-pic.png')
        },
        title: {
            type: String,
            default: null
        },
        desc: {
            type: String,
            default: null
        },
        id: {
            // 选项的唯一标识
            type: [Number, String],
            default: null
        },
        option: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapState(['skin']),
        isShowFillBlank() {
            if (
                this.isCheck &&
                this.option &&
                [OptionType.checkAndFillbank].includes(this.option.optionType)
            ) {
                return true;
            }
            return false;
        },
        isShowImage() {
            if (this.option && this.option.imageSettings && this.option.imageSettings.length) {
                return true;
            }
            return false;
        },
        imageSettings() {
            if (this.option && this.option.imageSettings) {
                return this.option.imageSettings;
            }
            return [];
        },
        placeholder() {
            return this.option.placeholder || '请简述内容';
        },
        isDarkSkin() {
            return this.skin === 'dark';
        }
    },
    watch: {
        value(n) {
            this.isCheck = n === this.id;
        }
    },
    data() {
        return {
            off,
            on,
            boff,
            bon,
            isCheck: this.value === this.id
        };
    },
    methods: {
        handleChangeSwitch() {
            // 单选组合已经选中时候，点击不触发反选
            // if (this.type === 'radio-group') {
            //     if (this.isCheck) {
            //         return;
            //     }
            // }
            this.$track(DB_ON_QUESTIONNAIR);
            this.isCheck = !this.isCheck;
            this.$emit('input', this.isCheck);
            this.$emit('on-change', this.isCheck, this.id, this.title);
        },
        handleInputValueChange(t) {
            this.$store.commit(CHANGE_PASS_VALIDATE, null);
        },
        handleFocus() {
            this.$track(DB_ON_QUESTIONNAIR);
        },
        handlePickImage(image) {
            ImagePreview({
                images: [image.url],
                closeable: true
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.radio {
    border: 2px solid rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    background: #fff;
    padding: 30px 28px;
    margin-bottom: 20px;
    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        .title {
            font-size: 30px;
            color: #000000;
            margin-right: 10px;
            word-break: break-all;
        }
        img {
            width: 43px;
            height: 43px;
        }
    }
    .desc {
        font-size: 28px;
        color: #999999;
        margin-top: 8px;
    }
    .img-wrap {
        margin-top: 16px;
        border: 1px solid rgba(0, 0, 0, 0.04);
        border-radius: 18px;
        overflow: hidden;
        img {
            width: 100%;
        }
    }
    .field-wrap {
        margin-top: 16px;
        /deep/ textarea {
            caret-color: #ff530d;
        }
    }
}
.active {
    border: 2px solid rgba(255, 85, 0, 0.2);
    background: rgba(255, 85, 0, 0.04);
}
</style>
